import { useEffect, useState } from 'react'
import { apiGet } from '../../Api_Functions'
import { useUser } from '../useUser'

const useUncheckedActions = () => {
  const [uncheckedActions, setUncheckedActions] = useState(0)
  const { user } = useUser()

  useEffect(() => {
    if (!user) return

    let mounted = true
    const interval = setInterval(async () => {
      try {
        const response = await apiGet('getUncheckedActionsCount')
        if (mounted) setUncheckedActions(response)
      } catch {
      }
    }, 1000)
    return () => {
      mounted = false
      clearInterval(interval)
    }
  }, [user])

  return uncheckedActions
}

export default useUncheckedActions
